// @flow

import * as React from 'react';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import UCheckIcon from './check_light.svg';
import UncheckIcon from './uncheck.svg';

const StyledWrapper = styled.div`
    text-decoration: none;
    user-select: none;
    text-decoration: none;
    letter-spacing: .5px;
    border: none;
    border-radius: 2px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-top: 3px;
    margin: auto;

    :hover{
        cursor: pointer;
    }
`;

/**
 * Checkbox z wewnętrznym stanem isVisible
*/
export default class UCheckbox extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: true,
        }
    }

    render() {
        return (
            <StyledWrapper
                onClick={() => {
                    this.setState({ isVisible: !this.state.isVisible }, () => {
                        this.props.onClick(this.state.isVisible);
                    })
                }}
            >
                <ReactSVG
                    path={this.state.isVisible ? UCheckIcon : UncheckIcon}
                    style={{
                        fill: '#215597',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                />
            </StyledWrapper>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/checkbox/UCheckbox.jsx